import * as $ from "jquery";
import * as React from "react";
import { useEffect, RefForwardingComponent, useRef, useImperativeHandle, forwardRef } from "react";
import { NumericOptions } from "../../JQuery/jquery.numeric";
import { Input, InputProps } from "./Input";

export interface NumericInputProps extends InputProps {
    options: NumericOptions;
}

export type NumericInputRef = {
    focus: Input["focusInput"];
};

const NumericInput: RefForwardingComponent<NumericInputRef, NumericInputProps> = (props, ref) => {
    const { options, disabled, readonly, ...restProps } = props;
    const inputRef = useRef<Input>();

    useImperativeHandle(ref, () => ({
        focus: (selectContent: boolean) => {
            inputRef.current?.focusInput(selectContent);
        },
    }));

    useEffect(() => {
        const inputElement = inputRef.current.inputRef.current;
        // do not enhance input if it's disabled or readonly
        // because jquery numeric always changes the value when pasting from clipboard
        // and triggers onChange fn
        if (!disabled && !readonly) {
            $(inputElement).numeric(options);
        }

        return () => {
            $(inputElement).removeNumeric();
        };
    }, [disabled, readonly]);

    return <Input {...restProps} disabled={disabled} readonly={readonly} ref={inputRef} />;
};

const NumericInputRef = forwardRef(NumericInput);

export { NumericInputRef as NumericInput };
